module.exports = ".input-group {\n    width: 100% !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-template-input/happy-input-template.component.css
// module id = ./src/app/shared/components/happy/happy-template-input/happy-input-template.component.css
// module chunks = main